import angular from 'angular';

angular.module('cloudX').controller('SectionConfigCtrl', ['resourceFactorySvc', SectionConfigCtrl]);

function SectionConfigCtrl(resourceFactorySvc) {
  var vm = this;
  vm.sections = [];
  vm.fields = {};
  vm.configs = {};

  vm.reload = function() {
    resourceFactorySvc.get('field').query(function(data) {
      vm.fields = data.reduce(function(o, e) {
        o[e.id] = e;
        return o;
      }, {});
    });
    resourceFactorySvc.get('sectionConfig').query(function(data) {
      //Group by sectionid
      vm.configs = data.reduce(function(o, e) {
        o[e.sectionId] = o[e.sectionId] || [];
        o[e.sectionId].push(e);
        return o;
      }, {});
    });
    vm.sections = resourceFactorySvc.get('section').query();
  };
  vm.reload();
}
